module.exports = "pegasus/assets/loader_grey.gif";